import { LocalStorageService } from 'angular-2-local-storage';
import { environment } from './../../../environments/environment';
import { AuthService, User } from './../services/auth.service';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { SlimLoadingBarService } from 'ops-lib';
import { NgSpinnerService } from 'ops-lib';
import { EMPTY } from 'rxjs';
import * as Sentry from '@sentry/browser';

const currentUserKey = 'ops.id.currentUser';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  cachedRequests: Array<HttpRequest<any>> = [];
  refreshTokenInProgress = false;
  user: User;
  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private toastr: ToastrService,
    public slimLoadingBarService: SlimLoadingBarService,
    public ngSpinnerService: NgSpinnerService,
    private localStorage: LocalStorageService,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(map(res => {
        if (res instanceof HttpResponse) {
          this.slimLoadingBarService.complete();
          this.ngSpinnerService.visible = false;
        }
        return res;
      }),
        catchError((err: HttpErrorResponse) => {
          if (err instanceof HttpErrorResponse) {
            this.slimLoadingBarService.complete();
            this.ngSpinnerService.visible = false;
            // RELOGIN IF INVALID GRANT
            if (err.status === 400 && err.error.error === 'invalid_grant') {
              window.location.href = environment.logoutRedirectUrl;
            }
            // REFRESH TOKEN IF UNAUTHORIZED
            if (err.status !== 401 && err.status !== 400 && err.status !== 403) {
              this.toastr.error(err.message);
              if (environment.production) {
                this.handleSentryError(err);
              }
              throw (err);
            }
            if (err.status === 401) {
              this.cachedRequests.push(req);
              if (this.cachedRequests.length === 1) {
                // this.localStorage.clearAll();
                this.authService.refreshToken().subscribe(
                  () => {
                    this.retryFailedRequests();
                  }
                );
              }
            }
            return EMPTY;
          }
        }));
  }

  public retryFailedRequests(): void {
    // retry the requests. this method can
    // be called after the token is refreshed
    this.cachedRequests.map(req => {
      this.http.request(req).subscribe(
        () => { }
      );
    });
    this.cachedRequests = [];
  }

  handleSentryError(error) {
    if (environment.production) {
      this.user = this.localStorage.get(currentUserKey) as User;
      if (this.user && this.user.contactId > 0) {
        Sentry.withScope(scope => {
          const email = (this.user.emailAddresses && this.user.emailAddresses.length > 0 && this.user.emailAddresses[0])
            ? this.user.emailAddresses[0] : '';
          scope.setUser({
            'email': email,
            'id': this.user ? this.user.contactId.toString() : '',
            'username': this.user ? this.user.fullName : ''
          });
          scope.setExtra(
            'exceptionMessage', error.error.exceptionMessage,
          );
          scope.setExtra(
            'exceptionType', error.error.exceptionType,
          );
          scope.setExtra(
            'stackTrace', (error.error.stackTrace as string).substring(0, 300),
          );
          scope.setExtra(
            'url', error.url,
          );
          Sentry.captureException(error.originalError || error);
        });
      } else {
        Sentry.captureException(error.originalError || error);
      }
    }
  }

}

